import { useRouter } from 'next/router';
import { decodeOrder, encodeOrder, pruneQuery } from '../queryEncoding';
import type { SortingOrder } from '../api/rest/types';

/**
 * Use sorting option persisted in the url query
 *
 * Changing sorting results in a router.push, which will trigger a data reload
 */
export const useSorting = (availableSortingOrders: SortingOrder[] = []) => {
  const { push, pathname, query } = useRouter();

  const defaultValue =
    availableSortingOrders.find((order) => order.default)?.key ?? availableSortingOrders[0]?.key;

  const sortingKey = decodeOrder(query) ?? defaultValue ?? 'relevance';

  const pushSortingChange = (newOrder: string) => {
    push(
      {
        // currently the /c/ prefix is internal-only, and rewritten in the middleware
        pathname: pathname.replace(/^\/c/, ''),
        query: pruneQuery({
          ...query,
          ...encodeOrder(defaultValue !== newOrder ? newOrder : undefined),
        }),
      },
      undefined,
      { scroll: false },
    );
  };

  return {
    sortingKey,
    pushSortingChange,
  };
};
